import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import { accessRightsService } from "@/core/services";
import { i18nHelper } from "@/core/utils";

const common = {
  methods: {
    actionUpdateRecordCompleteWithoutSuccessModal(
      response,
      title,
      initialStateAction,
      successAction,
      errorAction
    ) {
      if (response.code == 200) {
        successAction();
      } else {
        this.openErrorLayoutAppModalInfo(title, response, errorAction);
      }

      this.actionInitialState(initialStateAction);
    },
    actionCreateRecordComplete(
      response,
      title,
      initialStateAction,
      successAction,
      errorAction
    ) {
      if (response.code == 200) {
        this.openSuccessLayoutAppModalInfo(title, response, successAction);
      } else {
        this.openErrorLayoutAppModalInfo(title, response, errorAction);
      }

      this.actionInitialState(initialStateAction);
    },
    actionReadRecordComplete(
      response,
      title,
      initialStateAction,
      successAction
    ) {
      if (response.code == 200) {
        successAction(response);
      } else {
        if (response.message[0] == "Network Error") {
          console.log(response.message);
        } else {
          this.openErrorLayoutAppModalInfo(title, response);
        }
      }

      this.actionInitialState(initialStateAction);
    },
    actionUpdateRecordComplete(
      response,
      title,
      initialStateAction,
      successAction,
      errorAction
    ) {
      if (response.code == 200) {
        this.openSuccessLayoutAppModalInfo(title, response, successAction);
      } else {
        this.openErrorLayoutAppModalInfo(title, response, errorAction);
      }

      this.actionInitialState(initialStateAction);
    },
    actionInitialState(initialStateAction) {
      this.$store.dispatch(initialStateAction);
    },
    mapArrayToObjectData(array) {
      let newData = {};

      array.forEach((x) => {
        newData[x.key] = x.value;
      });

      return newData;
    },
    dynamicGetValueByKey(key) {
      return this[key];
    },
    openSuccessLayoutAppModalInfo(title, response, addOnOkAction) {
      let messages = response.message;
      let code = response.code;
      let buttons = [
        {
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            addOnOkAction();
            this.closeLayoutAppModalInfo();
          },
        },
      ];

      this.openLayoutAppModalInfo(title, messages, buttons, code);
    },
    openErrorLayoutAppModalInfo(title, response, addOnOkAction) {
      let code = response.code;
      let messages = response.message;
      let buttons = [
        {
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            addOnOkAction ? addOnOkAction() : null;
            this.closeLayoutAppModalInfo();
          },
        },
      ];
      this.openLayoutAppModalInfo(title, messages, buttons, code);
    },
    validationObjCheck(key, name) {
      this.$v[key][name].$touch();

      if (this.$v[key][name].$anyError) {
        return false;
      }

      return true;
    },
    validationCheck(keyName) {
      this.$v[keyName].$touch();
      if (this.$v[keyName].$anyError) {
        return false;
      }
      return true;
    },
    // this is for valitation each of 1 only ::start
    validationCheckEach(keyName, no) {
      // console.log(this.$v[keyName].$each[no]);
      this.$v[keyName].$each[no].$touch();
      if (this.$v[keyName].$each[no].$anyError) {
        return false;
      }
      return true;
    },
    // this is for valitation each of 1 only ::end
    validateObjState(key, name, isArray, no) {
      if (isArray) {
        // console.log('key:' + key);
        // console.log('name:' + name);
        // console.log(this.$v[key].$each[no][name]);
        // console.log('$dirty:' + $dirty);
        // console.log('$error:' + $error);
        // console.log($dirty ? !$error : null);
        const { $dirty, $error } = this.$v[key].$each[no][name];
        return $dirty ? !$error : null;
      } else {
        // console.log('key:' + key);
        // console.log('name:' + name);
        // console.log(this.$v[key]);
        // console.log(this.$v[key][name]);
        // console.log('$dirty:' + $dirty);
        // console.log('$error:' + $error);
        // console.log($dirty ? !$error : null);
        const { $dirty, $error } = this.$v[key][name];
        return $dirty ? !$error : null;
      }
    },
    validateState(name) {
      // console.log(name);
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    checkAccessRight(moduleName, action) {
      return accessRightsService.checkUserAccessRights(moduleName, action);
    },
    initBreadCrumb(data) {
      this.$store.dispatch(SET_BREADCRUMB, data);
    },
    openLayoutAppModalInfo(title, messages, buttons, code, textbox, dropbox) {
      this.$root.$children[0].$children[0].openInfoModal(
        title,
        messages,
        buttons,
        code,
        textbox,
        dropbox
      );
    },
    openLayoutAppModalMaintenance() {
      let title = i18nHelper.getMessage("label.maintenance");
      let messages = [];
      let buttons = [];

      messages.push(i18nHelper.getMessage("message.pageMaintenance"));

      buttons.push({
        text: i18nHelper.getMessage("label.ok"),
        variant: "primary",
        action: () => {
          this.closeLayoutAppModalInfo();
        },
      });

      this.$root.$children[0].$children[0].openInfoModal(
        title,
        messages,
        buttons
      );
    },
    closeLayoutAppModalInfo() {
      this.$root.$children[0].$children[0].closeInfoModal();
    },
  },
};

export default common;
